// extracted by mini-css-extract-plugin
export default {"album":"Album_album__ekTWA","label":"Album_label__NYvuR","hint":"Album_hint__Xq1BN"};